import { render, staticRenderFns } from "./DashboardShareSelectUser.vue?vue&type=template&id=42fe3bca&scoped=true"
import script from "./DashboardShareSelectUser.vue?vue&type=script&lang=js"
export * from "./DashboardShareSelectUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe3bca",
  null
  
)

export default component.exports